import { render, staticRenderFns } from "./RegQRcode.vue?vue&type=template&id=84392fb6&scoped=true&"
import script from "./RegQRcode.vue?vue&type=script&lang=js&"
export * from "./RegQRcode.vue?vue&type=script&lang=js&"
import style0 from "./RegQRcode.vue?vue&type=style&index=0&id=84392fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84392fb6",
  null
  
)

export default component.exports